"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Snippets = require("snippets");
var TextGrid = /** @class */ (function (_super) {
    __extends(TextGrid, _super);
    function TextGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextGrid.prototype.render = function () {
        var _a = this.props, data = _a.data, section = _a.section;
        var settings = section.settings, blocks = section.blocks;
        var article = data.template && data.template.name == "article";
        var foreground = settings && settings.foreground ? settings.foreground.toLowerCase() : article ? "charcoal" : "midnight";
        var background = settings && settings.background ? settings.background.toLowerCase() : article ? "transparent" : "arctic";
        var alinment = settings && settings.textalignment ? settings.textalignment.toLowerCase() : "";
        return settings && blocks ? (React.createElement("section", { className: "dynamic-text-grid bg-" + background + " text-" + (foreground == "midnight" ? "navy-dark" : foreground) },
            React.createElement(Snippets.Container, { width: "xl", className: "lg:px-9 md:px-2-4 px-0" },
                React.createElement("div", { className: "" },
                    React.createElement("div", { className: "flex flex-col md:flex-wrap md:flex-row mlg:-mx-8-8 md:-mx-4 mx-0" }, blocks
                        .filter(function (item) {
                        return item.settings.label ||
                            item.settings.title ||
                            item.settings.titletwo ||
                            item.settings.titlethree ||
                            item.settings.titlefour ||
                            item.settings.content;
                    })
                        .map(function (block, i) {
                        var width = settings.width ? width : "1/" + blocks.length;
                        var lastNum = blocks.length - 1;
                        return (React.createElement("div", { key: i, className: "block mlg:px-8-8 md:px-4 px-4-8 w-full md:w-" + width + " text-" + alinment + " pb-3-6 pt-6  md:py-6-4\n                      " + (lastNum != i ? " border-blue-grey md:border-r border-b" : "") },
                            block.settings.title && (React.createElement(Snippets.Heading, { size: "h4", className: "mb-1-6 font-semibold leading-tight" }, block.settings.title)),
                            block.settings.content && (React.createElement(Snippets.RichText, { className: "mb-2-4" + (foreground === "midnight" ? " text-grey-dark" : null) }, block.settings.content))));
                    })))))) : null;
    };
    TextGrid.sectionId = "txtgrid";
    return TextGrid;
}(React.PureComponent));
exports.TextGrid = TextGrid;
